const usePageChange =
  (pagination, setPagination) =>
  ({ selected }) => {
    const skip = selected * pagination.limit;
    setPagination((prev) => ({
      ...prev,
      currentPage: selected + 1,
      skip,
    }));
  };

export default usePageChange;
